
export class ParentControl {
    Administrativa: string
    Coordinador: string
    TiposBaja: string
    TiposSinGestion: string            
    TipoDiagnostico: string
    BajaNueva: string
    TarifaIndisposicion: string
    Fantiguedad: string
    DiasImpedirTareas: string
    FFinContrato: string;
    ReferenciaBaja: string;
    RefTrabajador: string;
    TipoBorrado: string;            
    ControlAcumulaciones: string;
    ComentarioParaEmpresa: string;
    ImprimirNombreLegalEnTareas: string;
    ObligarCitacionTelefonica: string;
    PAMEM: string;
    PES: string;
    ReclamarSolicitud: string;
    SabadoLaborable: string;
    SeguimientoPostCitacion: string;
    SinDatosMedicos: string;
    TieneSME: string;  
}